




import Vue from "vue";

export default Vue.extend({
    name: "IdentityLogin",
    props: {
        ticket: {
            type: String,
            required: true
        }
    },
    mounted() {
        this.$store.dispatch("login/identityLogin", {
            ticket: this.ticket,
            service: this.$constants.IDENTITY_CAS_PARAM_SERVICE
        });
    }
});
